import * as React from "react"
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import {fontFaceMoontime,headStyle,fontColorDark,barlow} from './welcome.module.scss'
import {extractCity} from '../utils/helperFunctions'

const Welcome = ({children,welimg,address,cname})=>{

    const formattedText = children.split('\n').map((line, index) => (
        <React.Fragment key={index}>
            {line}
            <br />
        </React.Fragment>
    ));

    const displayCityH1 = () => {
      let dc = extractCity(address);
      return dc && dc != 'Winter Park' ? `${dc}'s` : '';
    }

    const displayH1Suffix = () => {
      return cname == 'Olivia Flats' ? 'in Old Hyde Park' 
        : cname == 'Schoolhouse Flats' ? 'in Hyde Park' 
        : cname == 'Westshore Flats' ? 'in the Westshore Marina District' 
        : cname == 'Schooner Cove' ? 'on Ford Lake' 
        : cname == 'The Villas' ? 'near EMU and Washtenaw Community College' 
        : cname == 'Golfside Lake' ? '& Townhomes' 
        : cname == 'Willow Flats' ? 'in Hyde Park' :'';
    }

    let image = welimg ? getImage(welimg.gatsbyImageData) : false;
    return(
        <section id="welcome_text">
            <div className=" container">
                <div className="columns is-mobile is-multiline">
                    <div className="column is-full-mobile">
                        <h2 className={`${fontFaceMoontime} ${headStyle}`}>Welcome Home</h2>
                        <h1 className={`${fontColorDark} ${barlow}`} 

                        style={{fontSize:'25px',position:'relative',top:'-2rem'}}>{displayCityH1()} {cname} Apartments {displayH1Suffix()}</h1>
                        <p className={fontColorDark}>{formattedText}</p>
                    </div>
                    <div className="column">
                        <br />
                        {image && <GatsbyImage image={image} alt={`Welcome to ${cname}`} />}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Welcome
